import axios from "axios";

const qsRequest = axios.create({
    baseURL: '/api',
    timeout: 10000,
})

qsRequest.interceptors.request.use(config => {
    if (localStorage.getItem('auth_sid')) {
        config.headers.Authorization = `${localStorage.getItem('auth_sid')}`
    }
    return config
})

qsRequest.interceptors.response.use(response => {
    if (response.data.sid) {
        localStorage.setItem('auth_sid', response.data.sid)
    }
    return response
})

export default qsRequest